<script lang="ts">
    import {Question} from "../../models/Question";
    import {createEventDispatcher, onDestroy, onMount} from "svelte";
    import MedicalQuestionsPage from "./MedicalQuestionsPage.svelte";
    import {QuestionPage} from "../../models/QuestionPage";
    import {
        NavigationStateStore,
        QuestionAnswerMeta,
        StoredMedicalQuestions
    } from "../../services/Store";
    import {NavigationState} from "../../models/NavigationState";
    import {QuestionAnswerData} from "../../models/QuestionAnswerData";

    const dispatch = createEventDispatcher();

    let pages: QuestionPage[] = [];
    let questions: Question[] = [];
    let questionData: QuestionAnswerData;
    let maxPageNumber: Number = 0;
    let currentPageNumber: Number = 0;
    let displayContinueToNextPage = true;
    let continueToNextStep = false;
    let continueToNextStepEligible = false;

    let loadingImageUrl = process.env.ImagesUrl + 'images/Spinner.gif';
    let barImageUrl = process.env.ImagesUrl + 'images/animated-bar.png';

    let navState: NavigationState;

    const questionUnsubscribe = StoredMedicalQuestions.subscribe(value => pages = value);
    onDestroy(questionUnsubscribe);

    const navStateUnsubscribe = NavigationStateStore.subscribe(value => navState = value);
    onDestroy(navStateUnsubscribe);

    const questionDataUnsubscribe = QuestionAnswerMeta.subscribe(value => {
        questionData = value;
        if (questionData.complete) {
            continueToNextStepEligible = true;
        }
    });
    onDestroy(questionDataUnsubscribe);


    $: if (pages.length > 0) {
        maxPageNumber = pages.length;
        if (currentPageNumber == 0) {
            currentPageNumber = 1;
            let currentPage = pages[0];
            questions = currentPage.questions;
        }
        if (currentPageNumber === maxPageNumber) {
            displayContinueToNextPage = false;
            continueToNextStep = true;
        } else {
            displayContinueToNextPage = true;
        }
    }
    onMount(() => {
        window.scrollTo(0,0);
    });

    const continueButtonClicked = (event) => {
        const pageNumber = (event.detail.pageNumber) as Number;
        if (pageNumber < maxPageNumber) {
            currentPageNumber = currentPageNumber.valueOf() + 1;
            let currentPage = pages[currentPageNumber.valueOf() - 1];
            questions = currentPage.questions;
            if (continueToNextStepEligible) {
                continueToNextStep = true;
            } else {
                continueToNextStep = false;
            }
            window.scrollTo(0,0);
        } else {
            displayContinueToNextPage = false;
            continueToNextStep = true;
            window.scrollTo(0,0);
        }
    }

    const backButtonClicked  = (event) => {
        const pageNumber = (event.detail.pageNumber) as Number;
        if (pageNumber > 1)
        {
            currentPageNumber = currentPageNumber.valueOf() - 1;
            let currentPage = pages[currentPageNumber.valueOf() - 1];
            questions = currentPage.questions;
            if (continueToNextStepEligible) {
                continueToNextStep = true;
            } else {
                continueToNextStep = false;
            }
            window.scrollTo(0,0);
        }
    }
</script>

<div class="medical-questions">
    <div class="card-no-border">
        <h1>Medical Information</h1>
       <hr />
    </div>

    {#if !navState.medicalQuestionsRetrievalComplete}
        <div class="loading-panel">
            <div class="img-wrapper">
                <img src="{loadingImageUrl}" alt="Loading medical questions" />
            </div>
            <div class="text-wrapper">
                We are gathering your question set, thank you for your patience. Your wait time could take up to 30 seconds.
            </div>
            <div class="bar-wrapper">
                <img src="{barImageUrl}" alt="Loading medical questions" />
            </div>
        </div>

    {/if}

    {#if navState.medicalQuestionsRetrievalComplete}
    <div>
        <MedicalQuestionsPage questions="{questions}"
                              pageNumber={currentPageNumber}
                              continueToNextStep="{continueToNextStep}"
                              continueToNextPage="{displayContinueToNextPage}"
                              continueToNextStepEligible="{continueToNextStepEligible}"
                              pageTitle=""
                              displayButtons={true}
                                on:pageBackButtonClicked={backButtonClicked}
                                on:pageContinueButtonClicked={continueButtonClicked} />
    </div>
    {/if}
</div>

<style lang="scss">
  @use "../component_scss_library/colors" as color;
    .loading-panel {
      min-height: 400px;
      margin: 10px 0 120px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-content: center;
      .text-wrapper {
        font-size: 24px;
        color: color.$primary;
        font-weight: 700;
      }
      .img-wrapper {
        width: 140px;
        height: 140px;
        margin: auto;
        display: block;
      }
      img {
        text-align: center;
      }
      .bar-wrapper {
        visibility: hidden;
      }
    }

</style>
